import Mapper from '@/models/mappers/Mapper';
import { ShopifyProduct } from '@/models/entities/ShopifyProduct';
import { ShopifyProductDTO } from '@/api/dto/ShopifyProductDTO';
import { mapValueToInterface } from '@/utils/models';

export class ShopifyProductMapper extends Mapper<ShopifyProduct, ShopifyProductDTO> {
  mapFromDTO(productDTO: ShopifyProductDTO): ShopifyProduct {
    return new ShopifyProduct(<Partial<ShopifyProduct>>productDTO);
  }

  mapToDTO(product: ShopifyProduct): ShopifyProductDTO {
    return mapValueToInterface(product) as ShopifyProductDTO;
  }
}
